module.exports = __webpack_public_path__ + "img/icon_t3_c.bf258869.png";